import type { LocationQuery } from 'vue-router';
import baseURL from '@/helpers/base-url';
import i18next from '@/helpers/i18n';

function firstQueryValue(value: LocationQuery[string]): string | undefined {
  const single = Array.isArray(value) ? value[0] : value;
  return typeof single === 'string' && single ? single : undefined;
}

export function buildWorkOSSigninUrl(query: LocationQuery): URL {
  const signinUrl = new URL('/v2/auth/signin', baseURL);

  // Pass the current language to the backend since our custom accept-language won't be sent when setting window.location.href
  const lng = i18next.resolvedLanguage || i18next.language;
  if (lng) signinUrl.searchParams.set('lng', lng);

  const loginParams = firstQueryValue(query.loginParams);
  if (loginParams) {
    for (const [key, value] of new URLSearchParams(loginParams)) {
      signinUrl.searchParams.set(key, value);
    }
  }

  const redirect = firstQueryValue(query.redirect);
  if (redirect) signinUrl.searchParams.set('redirectUri', redirect);

  return signinUrl;
}
